/**
 * Frontend password validation utility.
 *
 * Mirrors the Django password validators configured on the backend:
 *  1. Must be at least 12 characters long.
 *  2. Must not consist entirely of digits.
 *
 * Note: "too similar to personal info" and "too common" checks remain
 * enforced server-side when the password is actually changed (via allauth).
 */

export interface PasswordValidationResult {
  valid: boolean;
  errors: string[];
}

export function validatePasswordLocally(
  password: string,
): PasswordValidationResult {
  const errors: string[] = [];

  if (password.length < 12) {
    errors.push('The password must contain at least 12 characters.');
  }

  if (/^\d+$/.test(password)) {
    errors.push('The password must not consist entirely of digits.');
  }

  return { valid: errors.length === 0, errors };
}
